import * as React from 'react';
import b_ from 'b_';

import './index.scss';

const b = b_.with('main-page-section');

interface Props {
  title?: string;
}

type Enhanced = Props;

const Section: React.FC<Enhanced> = ({ title, children }) => {
  return (
    <div className={b()}>
      {title && <h2 className={b('title')}>{title}</h2>}
      {children}
    </div>
  );
};

export default Section;
